import { Button } from 'components/ui';
import { StyledModal, ModalBody, ButtonContainer } from './UploadInspectionDataModal.style';

interface IConfirmUploadModalProps {
  open: boolean;
  handleContinue: () => void;
  handleCancel: () => void;
}

export const ConfirmUploadModal: React.FunctionComponent<IConfirmUploadModalProps> = ({
  open,
  handleContinue,
  handleCancel,
}) => {
  return (
    <StyledModal
      data-testid="upload-inspection-data-confirm-modal"
      title={'Confirm Continue'}
      open={open}
      onCancel={handleCancel}
      footer={null}
      maskClosable={false}
      destroyOnHidden
    >
      <ModalBody>
        <div>
          Are you sure you want to continue with invalid or incomplete data? The created Inspections
          may be incomplete or fail entirely.
        </div>
        <ButtonContainer>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button type="primary" onClick={handleContinue}>
            Continue
          </Button>
        </ButtonContainer>
      </ModalBody>
    </StyledModal>
  );
};
